export const USTATUS_ACTIVE= "active"
export const USTATUS_BLOCKED = "blocked"

export type ClientInfo = {
    Id          :string
    FirstName   :string
    MiddleName  :string
    LastName    :string
    BirthDate   :string
    BirthPlace  :string
    UserId      :string
    ClientId    :string
    Alias       :string
    Status      :string
    FundTransferLimit :number
    ClientEmail  :string
    ClientMobile :string
    CpassUname: string
}

export type BankAccountInfo = {
    AccountNumber       :string
    OutstandingBalance  :number
    AvailableBalance    :number
    AccountStatus       :string
    AccountTypeNo       :number
    DateOpened          :Date
}

export type LoanInfo = {
    LoanNumber          :string
    AccountNumber       :string
    OriginalPlacement   :number
    OutstandingBalance  :number
    PaymentStatus       :string
    DateOpened          :Date
    MaturityDate        :Date
    Term                :number
    LastPaymentDate     :Date
}

export type DeviceInfo = {
    id: string
    name: string
    type: 'ios' | 'android' | 'web' | 'desktop'
    lastAccessed: string
    lastAccessedUnix: number
    userId: string
    status: 'active' | 'blocked' | 'pending'
    authCapabilities: {
        hasPasskey: boolean
        passkeyData: any
        hasBiometric: boolean
        biometricData: any
    }
}

export function getClientHeader(client:ClientInfo):string {
    return client.LastName + "," + client.FirstName
}

export function getStatusColor(status:string):string {
    switch (status) {
        case "Active" :
        case "active":
            return "#00af00"
        case "Inactive":
            return "gray"
        case "Blocked":
        case "blocked":
            return "red"
        default:
            return "black"
    }
}